import { PERMISSIONS } from "@/constants/permissions";

import { DASHBOARD_ROLES, type DashboardRole } from "../types/dashboard-role.types";

export function resolveDashboardRole(permissionCodes: string[]): DashboardRole {
    if (permissionCodes.includes(PERMISSIONS.CALL_SVC_ADMIN_BASE)) {
        return DASHBOARD_ROLES.DEVELOPER;
    }

    if (
        permissionCodes.includes(PERMISSIONS.CALL_REPORTS_SALES_ADMIN) &&
        permissionCodes.includes(PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE)
    ) {
        return DASHBOARD_ROLES.CSO;
    }

    const isTeamLead = permissionCodes.includes(PERMISSIONS.CALL_SVC_TEAM_LEAD_BASE);
    const isSetting = permissionCodes.includes(PERMISSIONS.CALL_SETTING_PRIORITY_COUNTS);
    const canSelectTeamMember =
        permissionCodes.includes(PERMISSIONS.CALL_CALLS_SELECT_MEMBER) ||
        permissionCodes.includes(PERMISSIONS.CALL_APPOINTMENTS_SELECT_MEMBER) ||
        permissionCodes.includes(PERMISSIONS.CALL_KPIS_SELECT_MEMBER);

    if (isTeamLead || canSelectTeamMember) {
        return isSetting ? DASHBOARD_ROLES.SETTING_TEAM_LEAD : DASHBOARD_ROLES.SALES_TEAM_LEAD;
    }

    if (permissionCodes.includes(PERMISSIONS.CALL_SENIOR_SETTER)) {
        return DASHBOARD_ROLES.SENIOR_SETTER;
    }

    if (isSetting) {
        return DASHBOARD_ROLES.SETTING_AGENT;
    }

    return DASHBOARD_ROLES.SALES_AGENT;
}

export function hasRoleHomeDashboard(role: DashboardRole): boolean {
    return (
        role === DASHBOARD_ROLES.SALES_AGENT ||
        role === DASHBOARD_ROLES.SALES_TEAM_LEAD ||
        role === DASHBOARD_ROLES.SETTING_AGENT ||
        role === DASHBOARD_ROLES.SENIOR_SETTER ||
        role === DASHBOARD_ROLES.SETTING_TEAM_LEAD ||
        role === DASHBOARD_ROLES.CSO ||
        role === DASHBOARD_ROLES.CMO
    );
}
